/* ============================================================
   GO HONEY - make sure the cart note reaches checkout (added 2026-10-09)
   The note box is labelled "Gift message or order note" (locales/en.default.json).

   Venue saves the note through a request debounced by 1 second
   (CartTextInput in cart-components.js), and the textarea is not part of the
   cart form: its form= attribute points at <interactive-cart>, which shares
   the form's id. A shopper who taps Checkout within a second of typing would
   lose the message. This script:
   1. adds the current note to the cart form as a hidden "note" field when the
      form is submitted (Shopify's POST /cart saves it before checkout), and
   2. saves the note as soon as the box loses focus, for express checkout
      buttons (Shop Pay etc.) that never submit the form.
   ============================================================ */
(function () {
  if (window.ghCartNote) return;
  window.ghCartNote = true;

  const noteFor = (el) => {
    const scope = el.closest("interactive-cart") || document;
    return scope.querySelector('textarea[name="note"]');
  };

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute("action") || "";
      if (!/\/cart\/?(\?|$)/.test(action)) return;
      const box = noteFor(form);
      if (!box) return; // no note box rendered: send nothing, so an existing note is never cleared
      let hidden = form.querySelector('input[type="hidden"][data-gh-note]');
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "note";
        hidden.setAttribute("data-gh-note", "");
        form.appendChild(hidden);
      }
      hidden.value = box.value;
    },
    true
  );

  document.addEventListener("focusout", (event) => {
    const box = event.target;
    if (!(box instanceof HTMLTextAreaElement) || box.name !== "note") return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ note: box.value }),
    }).catch(() => {});
  });
})();
